import axios from 'axios';
import React, { createContext, useContext, useEffect, useState } from 'react';
import config from '../config';
// import jwt from 'jwt-simple';
// import { config } from 'dotenv'; 
// import dotenv from 'dotenv';
// dotenv.config();
// config();


// const REACT_APP_API_URL = import.meta.env.VITE_REACT_APP_ENV === 'dev' ? import.meta.env.VITE_BASE_URL_DEV : import.meta.env.VITE_BASE_URL_PROD;
const REACT_APP_API_URL = config.backendUrl;
// console.log(REACT_APP_API_URL)

const AuthContext = createContext({});


export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [logs, setLogs] = useState([]);   
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    checkAuth(); 
  }, []);

  const checkAuth = async () => {
    console.log('Checking auth');
    try {
      const token = localStorage.getItem('token');
      if (token) {
        const response = await axios.get( REACT_APP_API_URL + '/auth/verify', {
          headers: { Authorization: `Bearer ${token}` }
        });
        console.log(response.data);
        console.log(response.data.accessLogs);
        console.log(response.data.user);
        setUser(response.data.user);
        setLogs(response.data.accessLogs);
      }
    } catch (err) {
      setError(err.message);
      localStorage.removeItem('token');
    } finally {
      setLoading(false);
    }
  };

  const register = async (credentials) => {
    // console.log('Registering');
    try {
      const response = await axios.post(REACT_APP_API_URL + '/auth/register', credentials);
      localStorage.setItem('token', response.data.token);
      setUser(response.data.user);
      
      return response.data;
    } catch (err) {
      setError(err.message);
      throw err;
    }
  };  

  const emailVerify = async (searchParams) => {
    try {
      
      
      const response = await axios.get(REACT_APP_API_URL + `/auth/verify-email${searchParams}`);
      console.log(response.data);
      return response.data;
    } catch (err) {
      setError(err.message);
      throw err;
    }
  };

  const login = async (credentials) => {
    // console.log('Logging in');
    try {
      const response = await axios.post(REACT_APP_API_URL + '/auth/login', credentials);
      localStorage.setItem('token', response.data.token);
      setUser(response.data.user);
      setLogs(response.data.logs);
      return response.data;
    } catch (err) {
      setError(err.message);
      throw err;
    }
  };

  const logout = () => {
    // console.log('Logging out');
    localStorage.removeItem('token');
    setUser(null);
  };

  const forgotPassword = async (email) => {
    const response = await axios.post(`${REACT_APP_API_URL}/auth/forgot-password`, { email });
    return response.data;
  };

  const resetPassword = async (token, newPassword) => {
    const response = await axios.post(`${REACT_APP_API_URL}/auth/reset-password`, {
      token,
      newPassword
    });
    return response.data;
  };

  const updateEmail = async (newEmail) => {
    try {
      const response = await axios.put(
        `${REACT_APP_API_URL}/auth/update-email`,
        { email: newEmail },
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
      );
      setUser({ ...user, email: newEmail });
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const updateProfile = async (profileData) => {
    try {
      const response = await axios.put(
        `${REACT_APP_API_URL}/auth/update-profile`,
        profileData,
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
      );
      setUser({ ...user, ...profileData });
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const updatePassword = async (currentPassword, newPassword) => {
    try {
      const response = await axios.put(
        `${REACT_APP_API_URL}/auth/update-password`,
        { currentPassword, newPassword },
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const deleteAccount = async (password) => {
    try {
      await axios.delete(
        `${REACT_APP_API_URL}/auth/delete-account`,
        { 
          data: { password },
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } 
        }
      );
      logout();
    } catch (error) {
      throw error;
    }
  };

  const value = {
    user,
    loading,
    error,
    login,
    logout,
    register,
    logs,
    forgotPassword,
    resetPassword,
    emailVerify,
    updateEmail,
    updateProfile,
    updatePassword,
    deleteAccount,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext); 